import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { firestore } from '../../../firebase';
import { dateInputFormatterByValue } from '../../../helpers/dateFormatter';
import StateContext from '../../../StateContext';
import BudgetCategoriesSelector from './BudgetCategoriesSelector';
import EditBudgetElementArray from './BudgetElement/EditBudgetElementArray';

function EditBudgetElement({elId}) {

    const {id} = useParams();

    const appState = useContext(StateContext);

    const [sum, setSum] = useState(0);
    const [description, setDescription] = useState("");
    const [categoryId, setCategoryId] = useState("");
    const [date, setDate] = useState("");
    const [month, setMonth] = useState();
    const [type, setType] = useState("expense");
    const [year, setYear] = useState();

    const [elements, setElements] = useState([])

    const [error, setError] = useState("");
    const [message, setMessage] = useState("");

    useEffect(() => {
        if (appState.userId) {
            console.log(appState.userId, "userId", id, "paramId")
            try {
                const budgetElRef = firestore.collection("users").doc(appState.userId).collection("budget").doc(id);
                budgetElRef.onSnapshot(doc => {
                    const budgetEl = {id: doc.id, ...doc.data()}

                    setCategoryId(budgetEl.category);
                    setDescription(budgetEl.description);
                    setType(budgetEl.type)
                    const inputDate = dateInputFormatterByValue(budgetEl.date);
                    setDate(inputDate);
                    setMonth(budgetEl.month);
                    setYear(budgetEl.year);
                    setSum(budgetEl.sum);
                    setElements(budgetEl.elements);
                });
    
    
            } catch (error) {
                
                
                console.log(error)
            }
        }

    }, [elId, appState.userId]);

    async function editHandler(e) {
        e.preventDefault();
        try {
            const budgetElRef = firestore.collection("users").doc(appState.userId).collection("budget").doc(id);
            console.log(elements, "Elements")
            const data = {
                sum,
                description,
                date,
                category: categoryId,
                month,
                year,
                type,
                elements

            }
            budgetElRef.update(data);
            setMessage("Oppdatert");
        } catch (error) {
            setError("Kunne ikke oppdatere")
            console.log(error);
        }
    }

    return (
        <div className="container my-4">
            <form onSubmit={editHandler}>
                <label>Utgift</label>
                <input type="number" value={sum} onChange={e => setSum(e.target.value)} className="form-control mb-2" />

                {categoryId && <BudgetCategoriesSelector categoryId={categoryId} type={type} setCategory={setCategoryId} />}


                <label>Dato</label>
                <input type="date" value={date} onChange={e => setDate(e.target.value)} className="form-control mb-2" />

                <label>Beskrivelse</label>
                <textarea className="form-control mb-2" value={description} onChange={e => setDescription(e.target.value)} />

                <EditBudgetElementArray elements={elements} setElements={setElements}  />

                {message && <div className="alert alert-success">{message}</div>}
                {error && <div className="alert alert-danger">{error}</div>}
                <button className="btn btn-success btn-block mt-3">Lagre</button>

            </form>
        </div>
    )

}
export default EditBudgetElement